export default "__VITE_ASSET__BriQuLIz__"